import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ReflectionInfoFragmentDoc } from './ReflectionInfo.generated';
import { ProductBaseInfoFragmentDoc } from './Product.generated';
import { ProductPriceRangeFragmentDoc } from './ProductPriceRange.generated';
export type ReflectionCardFragment = { id: string, pk: number, name: string, shortName: string, slug: string, videoUrl: string | null, product: { quickAddLayout?: Types.QuickAddLayoutEnum, wholesaleQuickAddLayout?: Types.QuickAddLayoutEnum, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, thumbnail: { lg: string | null, sm: string | null }, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, wholesalePriceRange?: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } } | null, variantImages: Array<{ id: string, thumbnail: { lg: string | null, sm: string | null } }>, similarSpecifics: Array<{ id: string, pk: number, thumbnail: { lg: string | null, sm: string | null }, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, specifics: Array<{ id: string, pk: number, slug: string, name: string, shortName: string }> }> } | null };

export const ReflectionCardFragmentDoc = gql`
    fragment ReflectionCardFragment on ProductSiteSpecificsType {
  ...ReflectionInfoFragment
  product {
    ...ProductBaseInfoFragment
    thumbnail {
      lg(method: CROP_WEBP)
      sm(size: "300x0", method: CROP_WEBP)
    }
    priceRange {
      ...ProductPriceRangeFragment
    }
    wholesalePriceRange @include(if: $wholesale) {
      ...ProductPriceRangeFragment
    }
    quickAddLayout @skip(if: $wholesale)
    wholesaleQuickAddLayout @include(if: $wholesale)
    variantImages {
      id
      thumbnail {
        lg
        sm(size: "300x0")
      }
    }
    similarSpecifics: related @include(if: $withSimilar) {
      id
      pk
      thumbnail {
        lg
        sm(size: "300x0")
      }
      priceRange {
        ...ProductPriceRangeFragment
      }
      specifics(filters: {siteSpecifics: true}) {
        id
        pk
        slug
        name
        shortName
      }
    }
  }
}
    ${ReflectionInfoFragmentDoc}
${ProductBaseInfoFragmentDoc}
${ProductPriceRangeFragmentDoc}`;